const cookChefDetailedRateCard = {
  key: "cook-chef",
  title: "Cook / Chef Detailed Rate Card",
  note:
    "Indicative cooking pricing. Final cost depends on meal complexity, number of family members, cuisine type, and frequency.",
  sections: [
    {
      title: "One-time Cooking",
      items: [
        { name: "One-time home cooking visit", price: "₹599 onwards" },
        { name: "Special dish session", price: "₹899 onwards" },
      ],
    },
    {
      title: "Monthly Support",
      items: [
        { name: "Daily home cook - basic meals", price: "₹2499-₹6999 per month" },
        { name: "Cook with multi-meal requirement", price: "₹3999-₹9999 per month" },
      ],
    },
    {
      title: "Consultation",
      items: [
        { name: "Event / menu planning consult", price: "₹399" },
      ],
    },
  ],
};

export default cookChefDetailedRateCard;